module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"button":{"cancel":"キャンセル"}},"en":{"button":{"cancel":"Cancel"}}}')
  delete Component.options._Ctor
}
